var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { combineReducers } from "redux";
import currentUserDetailsReducersMapObject from "@ane/exp-data/lib/userDetails/CurrentUserDetailsReducer";
import getWorkspaceReducersMapObject from "@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.ducks";
import UserAccessReducersMapObject from "@ane/exp-ux/lib/components/GetUserAccess/UserAccess.reducer";
import "./views/Create/ducks/AnalysisConfigCreate.ducks.js";
import "./views/Edit/ducks/AnalysisConfigEdit.ducks.js";
import "./views/List/ducks/AnalysisConfigList.ducks.js";
import { reducer } from "./views/Create/components/AnalysisConfigCreateContainer/Create.ducks.js";
import { reducer as reducer$1 } from "./views/Edit/components/AnalysisConfigEditContainer/Edit.ducks.js";
import { reducer as reducer$2 } from "./views/List/components/AnalysisConfigListContainer/List.ducks.js";
const analysisConfigModuleReducer = __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, currentUserDetailsReducersMapObject), getWorkspaceReducersMapObject), UserAccessReducersMapObject), {
  analysisConfigManagementModule: combineReducers({
    analysisConfigCreate: reducer,
    analysisConfigEdit: reducer$1,
    analysisConfigList: reducer$2
  })
});
export {
  analysisConfigModuleReducer,
  analysisConfigModuleReducer as default
};
//# sourceMappingURL=reducers.js.map
